import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { LoginService } from 'app/services/login.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private routes: Router,
    private loginService: LoginService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

      // Check if isUserLoggedIn i.e. is user is verified user and not just signed up.
      if (this.loginService.isUserLoggedIn) {
        return true;
      }

      // Check if isUserSignedUp if url is addcompanydetails
      if (state.url === '/login/addcompanydetails' && this.loginService.isUserSignedUp) {
        return true;
      }

      // If not check session storage and set isUserLoggedIn
      return this.loginService.checkAndSetUserDetailsFromSessionStorage();

  }
  
}
